<template>
  <v-card flat tile class="budgets-group-index">
    <v-card-text>
      <v-row class="align-end">
        <v-col cols="8">
          <span class="d-inline-flex">
            <h2>GL Groups |</h2><h4 class="ml-3 grey-text text--lighten-1">{{templateObject.title}}</h4>
          </span>
          <!--<v-row class="template-title">
            <v-col cols="12">
              <span class="font-weight-500">{{templateObject.title}}</span> | Ordered by: {{orderByColumn}}
            </v-col>
          </v-row>-->
          <!--<v-row class="property-list">
            <v-col cols="12">
              Properties:
              <res-dynamic-list 
                :values="propertyNames"
                :maxCharacterCount="100">
              </res-dynamic-list>
            </v-col>
          </v-row>-->
        </v-col>
        <v-col class="d-flex justify-end edit-template-button" cols="4">
          <res-button height='30px'
                      :dark="true"
                      :depressed="true"
                      buttonText='TEMPLATE SETTINGS'
                      :outline="true"
                      backgroundColor='white'
                      borderColor='var(--v-resBlue-darken1)'
                      buttonTextColor='var(--v-resBlue-darken1)'
                      @click="openNewEditTemplateDialog"
                      font-size="12px"></res-button>
          <res-button v-if="templateObject.isArchived === false"
                      height='30px'
                      :depressed="true"
                      buttonText='+ BUDGET GROUP'
                      :outline="true"
                      backgroundColor='var(--v-resGreen-base)'
                      borderColor='white'
                      buttonTextColor='white'
                      @click="openNewEditGroupDialog()"
                      class="ml-3"
                      font-size="12px">
          </res-button>
          <div class="help-controls step-down ml-2" @click="openHelp(null)">
            <span class="help-label">Help</span>
            <v-icon color="var(--v-resBlue-darken1)" class="pb-1">mdi-help-circle</v-icon>
          </div>
          <res-dialog :showDialog="showHelp"
                      titleClass="resBlue darken-1 white--text"
                      iconColor="white"
                      cancelButtonText="Close"
                      :cancelButtonOnly="true"
                      cancelButtonColor="resBlue darken-1"
                      :maxWidth="800"
                      :setWidth="800"
                      :setHeight="600"
                      attach=".budgets-group-index"
                      @cancel="closeHelp">
            <templates-help :openSection="openHelpSection"></templates-help>
          </res-dialog>
          <new-edit-template-dialog v-if="showNewEditTemplateDialog"
                                    :showDialog="showNewEditTemplateDialog"
                                    :maxWidth="775"
                                    :setWidth="775"
                                    mode="edit"
                                    :template="templateToEdit"
                                    @save="saveTemplate"
                                    @cancel="cancelNewEditTemplateDialog"
                                    @copy="openCopyTemplateDialog"
                                    @archive="openArchiveTemplateDialog">
          </new-edit-template-dialog>
          <copy-template-dialog :showDialog="showCopyTemplateDialog"
                                :templateTitle="templateObject.title"
                                @confirmCopy="copyTemplate"
                                @cancelCopy="cancelCopyTemplateDialog">
          </copy-template-dialog>
          <archive-template-dialog :showDialog="showArchiveTemplateDialog"
                                   :templateTitle="templateObject.title"
                                   :restoreMode="templateObject.isArchived"
                                   @confirmArchive="archiveTemplate"
                                   @cancelArchive="cancelArchiveTemplateDialog">
          </archive-template-dialog>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="d-flex" cols="12">
          <res-data-table 
            :headers="headers"
            :items="budgetGroups"
            :show-select="false"
            :draggable="templateObject.sortType == 2"
            :single-select="true"
            item-key="groupId"
            :slotOptions="['action', 'groupName']"
            @selected-items="updateSelectedItems($event)"
            @sorted="updateSortOrder">
            <template v-slot:[`item.groupName`] ="{ item }">
              <div class="d-flex">
                <v-icon v-if="templateObject.sortType == 2 && item.groupId">mdi-arrow-up-down</v-icon>
                <span class="pr-6" v-if="!(templateObject.sortType == 2 && item.groupId)"></span>
                <span class="pl-2">{{item.groupName}}</span>
              </div>
            </template>
            <template v-slot:[`item.action`] ="{ item }">
              <div class="">
                <v-icon color="resBlue" v-if="item.isExclusionGroup == true" @click="openExcludedGroupDialog()" :ripple="false">mdi-pencil</v-icon>
                <v-icon color="resBlue" v-else @click="openNewEditGroupDialog(item.groupId)" :ripple="false">mdi-pencil</v-icon>
                <v-menu offset close-on-click>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" background-color="white" :disabled="!(templateObject.isArchived === false && item.isSystem === false)" icon color="var(--v-resBlue-darken1)" class="ml-2">
                      <v-icon>mdi-dots-horizontal</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item>
                      <v-list-item-title>
                          <span class="pointer" @click="openDeleteGroupDialog(item)">Delete GL Group</span>
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
            </template>
          </res-data-table>
        </v-col>
      </v-row>

    </v-card-text>
    <new-edit-group-dialog 
      v-if="showNewEditGroupDialog"
      :showDialog="showNewEditGroupDialog"
      :maxWidth="775"
      :setWidth="775"
      :mode="groupMode"
      :groupId="selectedGroupId"
      :templateId="templateObject.templateId"
      :readonly="templateObject.isArchived === true"
      @save="saveGroup"
      @cancel="cancelNewEditGroupDialog">
    </new-edit-group-dialog>
    <excluded-group-dialog 
      v-if="showExcludedGroupDialog"
      :showDialog="showExcludedGroupDialog"
      :maxWidth="530"
      :setWidth="530"
      :templateId="templateObject.templateId"
      @cancel="cancelExcludedGroupDialog">
    </excluded-group-dialog>
    <delete-group-dialog
      :showDialog="showDeleteGroupDialog"
      :groupName="selectedGroupName"
      @confirmDelete="deleteGroup"
      @cancelDelete="cancelDeleteGroupDialog">
    </delete-group-dialog>
  </v-card>
</template>

<script>
  import ResButton from '@/components/base/ResButton';
  import ResDataTable from '@/components/base/ResDataTable.vue';
  //import ResDynamicList from '@/components/base/ResDynamicList.vue';
  import NewEditTemplateDialog from '../dialogs/NewEditTemplateDialog.vue';
  import CopyTemplateDialog from '../dialogs/CopyTemplateDialog.vue';
  import ArchiveTemplateDialog from '../dialogs/ArchiveTemplateDialog.vue';
  import NewEditGroupDialog from './dialogs/NewEditGroupDialog.vue';
  import ExcludedGroupDialog from './dialogs/ExcludedGroupDialog.vue';
  import DeleteGroupDialog from './dialogs/DeleteGroupDialog.vue';

  import ResDialog from '@/components/base/ResDialog.vue';
  import TemplatesHelp from '@/components/help/TemplatesHelp.vue';
  import HelpableMixin from '@/mixins/Helpable.js';

  import {Constants} from '@/utilities/constants/index.js'
  import templateService from '@/services/template'
  import groupService from '@/services/group'

  import { mapActions } from 'vuex'

  export default {
    name: 'BudgetGroupsIndex',
    mixins: [HelpableMixin],
    components: {
      ResButton,
      ResDataTable,
      ResDialog,
      //ResDynamicList,
      NewEditTemplateDialog,
      CopyTemplateDialog,
      ArchiveTemplateDialog,
      NewEditGroupDialog,
      TemplatesHelp,
      ExcludedGroupDialog,
      DeleteGroupDialog
    },
    props: {
      templateId: {
        required: true
      }
    },
    data: function () {
      return {
        showNewEditTemplateDialog: false,
        showCopyTemplateDialog: false,
        showArchiveTemplateDialog: false,
        templateObject: {},
        templateToEdit: {sortType: 1},
        showNewEditGroupDialog: false,
        showExcludedGroupDialog: false,
        showDeleteGroupDialog: false,
        selectedGroupId: Constants.EMPTY_GUID,
        selectedGroupName: '',
        groupDialogMode: 'edit'
      };
    },
    computed: {
      orderByColumn() {
        return ['Alphabetic', 'GL Account', 'Custom'][this.templateObject.sortType || 0]
      },
      templateName() {
        return this.title
      },
      headers: {
        get() {
          return this.templateObject.headers;
        }
      },
      budgetGroups: {
        get() {
          return this.templateObject.groups;
        },
      },
      propertyNames() {
        if (this.templateObject.properties) {
          return this.templateObject.properties.map(function (p) { return p.name; });
        }
        else {
          return [];
        }
      },
      groupMode() {
        return this.groupDialogMode;
      }
    },
    methods: {
      ...mapActions(['changeLoading', 'activateErrorDialog']),
      async fetchBudgetGroups() {
        this.changeLoading(true);
        let self = this;
        let response = await templateService.getTemplate(this.templateId);
        self.templateObject = response;
        self.templateToEdit = {
          templateId: response.templateId, 
          name: response.title, 
          isArchived: response.isArchived,
          sortType: response.sortType,
          lastModifiedTimestamp: response.lastModifiedTimestamp,
          selectedProperties: response.properties.map((item) => {
            return {
              text: item.name,
              value: item.propertyId
            };
          })
        };
        this.changeLoading(false);
      },
      /* Edit Template Logic */
      openNewEditTemplateDialog() {
        this.showNewEditTemplateDialog = true;
      },
      cancelNewEditTemplateDialog() {
        var self = this;
        self.showNewEditTemplateDialog = false;
        // reset template
        self.templateToEdit = {
          templateId: self.templateObject.templateId,
          name: self.templateObject.title,
          isArchived: self.templateObject.isArchived,
          sortType: self.templateObject.sortType,
          selectedProperties: self.templateObject.properties.map((item) => {
            return {
              text: item.name,
              value: item.propertyId
            };
          }) };
      },
      async saveTemplate() {
        let self = this;
        self.changeLoading(true);
        const propertyIds = self.templateToEdit.selectedProperties.map(prop => { return prop.value; });
        let response = await templateService.updateTemplate(self.templateToEdit.templateId, self.templateToEdit.name, propertyIds, self.templateToEdit.sortType, self.templateToEdit.lastModifiedTimestamp);
        if (response.success == true) {
          self.templateObject.title = self.templateToEdit.name;
          self.templateObject.properties = self.templateToEdit.selectedProperties.map((item) => {
            return {
              name: item.text,
              propertyId: item.value
            };
          });
          self.showNewEditTemplateDialog = false;
          self.changeLoading(false);
        } else {
          self.changeLoading(false);
          //this is handled generically in services/api/index.js
          //this.activateErrorDialog({title: 'Update Template Failed', message: response.data});
        }
        this.fetchBudgetGroups();
      },
      /* Edit Group Logic */
      openNewEditGroupDialog(groupId) {
        this.selectedGroupId = groupId || Constants.EMPTY_GUID;
        this.groupDialogMode = this.selectedGroupId == Constants.EMPTY_GUID ? 'add' : 'edit';
        this.showNewEditGroupDialog = true;
      },
      cancelNewEditGroupDialog() {
        this.selectedGroupId = Constants.EMPTY_GUID;
        this.showNewEditGroupDialog = false;
      },
      async saveGroup(selectedGLIds, group) {
        let self = this;
        self.changeLoading(true);
        let groupData = { groupId: this.selectedGroupId, selectedGLAccountIds: selectedGLIds, groupName: group.groupName, groupTypeId: group.groupTypeId, templateId: self.templateObject.templateId, lastModifiedTimestamp: group.lastModifiedTimestamp }; 
        let response = await (this.groupDialogMode == 'add' ? groupService.create(groupData) : groupService.update(groupData));
        if (response.success) {
          self.fetchBudgetGroups();
          this.showNewEditGroupDialog = false;
          self.changeLoading(false);
        } else {
          self.changeLoading(false);
          this.activateErrorDialog({title: 'Save Group Failed', message: response.data});
        }
      },
      /* Excluded Group Logic */
      openExcludedGroupDialog() {
        this.showExcludedGroupDialog = true;
      },
      cancelExcludedGroupDialog() {
        this.showExcludedGroupDialog = false;
      },
      /* Delete Group Logic */
      openDeleteGroupDialog(group) {
        this.selectedGroupId = group.groupId;
        this.selectedGroupName = group.groupName;
        this.showDeleteGroupDialog = true;
      },
      async deleteGroup() {
        this.changeLoading(true);
        let response = await groupService.delete(this.selectedGroupId, this.templateId);
        this.showDeleteGroupDialog = false;
        if (response.success) {
          this.fetchBudgetGroups();
        } else {
          this.activateErrorDialog({title: 'Delete Group Failed', message: response.data});
        }
        this.changeLoading(false);
      },
      cancelDeleteGroupDialog() {
        this.showDeleteGroupDialog = false;
      },
      /* Copy Template Logic */
      openCopyTemplateDialog(template) {
        this.selectedTemplate = template;
        this.showCopyTemplateDialog = true;
      },
      cancelCopyTemplateDialog() {
        this.selectedTemplate = {};
        this.showCopyTemplateDialog = false;
      },
      async copyTemplate() {
        var t = this;
        t.changeLoading(true);
        let response = await templateService.copyTemplate(t.templateId);
        if (response.success) {
          t.showCopyTemplateDialog = false;
          t.showNewEditTemplateDialog = false;
          t.changeLoading(false);
          t.$router.push({ name: 'BudgetGroups', params: { templateId: response.data } });
        } else {
          t.changeLoading(false);
          //this is handled generically in services/api/index.js
          //this.activateErrorDialog({title: 'Copy Template Failed', message: response.data});
        }
      },
      /* Archive Template Logic*/
      openArchiveTemplateDialog(template) {
        this.selectedTemplate = template;
        this.showArchiveTemplateDialog = true;
      },
      cancelArchiveTemplateDialog() {
        this.selectedTemplate = {};
        this.showArchiveTemplateDialog = false;
      },
      async archiveTemplate() {
        let t = this;
        t.changeLoading(true);
        let response = await templateService.archiveTemplate(t.templateId, t.templateToEdit.isArchived == false);
        if (response.success) {
          t.showArchiveTemplateDialog = false;
          t.changeLoading(false);
          if (t.templateToEdit.isArchived == false) {
            t.$router.push({ name: 'GLAccountTemplatesLanding' });
          } else {
            // un-archiving
            t.templateObject.isArchived = false; 
            t.templateToEdit.isArchived = false;
          }
        } else {
          t.changeLoading(false);
          //this is handled generically in services/api/index.js
          //this.activateErrorDialog({title: 'Archive Template Failed', message: response.data});            
        }
      },
      sortByUpdated(val) {
        this.orderByColumn = this._.find(this.headers, { value: val }).text;
      },
      async updateSortOrder(e) {
        if (this.templateObject) {
          var groups = (this.templateObject && this.templateObject.groups || []);
          this.templateObject.groups = groups.map((group, index) => {
            group.sortOrder = index;
            return group;
          });
          this.templateObject.groups[e.oldIndex].sortOrder = e.newIndex;
          this.templateObject.groups = groups.map((group, index) => {
            if (e.oldIndex < e.newIndex) {
              if (index > e.oldIndex && index <= e.newIndex) {
                group.sortOrder--;
              }
            }
            else {
              if (index >= e.newIndex && index < e.oldIndex) {
                group.sortOrder++;
              }
            }
            return group;
          });
          await groupService.updateSortOrders(this.templateObject.groups)
          this.templateObject = {};
          this.fetchBudgetGroups();
        }
      }
    },
    created() {
      this.fetchBudgetGroups();
    },
    watch: {
      $route(to, from) {
          if (to.params.templateId != from.params.templateId) {
            this.fetchBudgetGroups();
          }
      }
    }
  };
</script>

<style lang="scss" scoped>
  .help-controls {
    float: right;
    height: 36px;
    border-radius: 5px;
    border: solid 1px var(--v-resGrey-lighten3);
    padding: 7px 6px 6px 6px;
    cursor: pointer;
  }
</style>

<style lang="scss">
  .resman-tab {
    color: var(--v-resGrey-darken1) !important;
    font-weight: normal !important;
    font-size: 18px !important;
  }

    .resman-tab.resman-active-tab {
      font-weight: 500 !important;
      color: var(--v-resBlue-darken1) !important;
    }

  .v-data-table-header th.resGrey-background {
    background-color: var(--v-resGrey-lighten3) !important;
  }

  .template-title {
    //padding-bottom: 24px;
    .col
  {
    width: 470px;
    /*height: 18px;*/
    font-family: Roboto;
    font-size: 15.2px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: var(--v-resGrey-darken2);
    padding-top:0;
    padding-bottom:0;
  }
  }

  .property-list {
    padding: 0;
    margin-bottom: -19px;
    .col
  {
    width: 497px;
    font-family: Roboto;
    font-size: 12px;
    font-weight: normal;
    padding-top: 5px;
    padding-bottom: 0;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: var(--v-resGrey-darken2);
  }
  }

  a.action-link {
    color: var(--v-resBlue-darken1);
    font-family: Roboto;
    font-size: 13.5px;
    letter-spacing: normal;
  }

  .link-btn.v-btn span.v-btn__content {
    color: var(--v-resBlue-darken1);
    font-family: Roboto;
    font-size: 13.5px;
    letter-spacing: normal;
    font-weight: normal;
  }

  .link-btn:before {
    background-color: #fff;
    transition: none;
  }
  .vuetify-parent div .v-btn.theme--light.v-btn.v-btn--disabled {
    background-color: white !important;
  }

</style>
